import styled from '../styled';

export const mobileHeroLeadText = `
  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 1.55;
  }
`;

export const mobileLeadText = `
  @media (max-width: 600px) {
    font-size: 15px;
    line-height: 1.55;
  }
`;

export const HeroLead = styled('p')`
  font-size: 19px;
  line-height: 1.6;
  color: #4f4f4f;
  margin: 0;
  ${mobileHeroLeadText}
`;

export const StoryLead = styled('p')`
  font-size: 17px;
  line-height: 1.65;
  color: #4f4f4f;
  margin: 0;
  ${mobileLeadText}
`;

export const SectionTagline = styled('p')`
  font-size: 17px;
  font-weight: 600;
  line-height: 1.5;
  color: #0e1c2b;
  margin: 12px 0 0;
  ${mobileLeadText}
`;
